import React from "react";

const Concept = props => {
  return (
    <div>
      <p className="step-p"> A global network of computers work together to keep the blockchain secure, correct, and consistent. </p>
    </div>
  );
};

export default Concept;


// WEBPACK FOOTER //
// ./src/steps/p2p/concept.js